import { css } from 'linaria';

export const lastProjectsText = css`
  && {
    width: 774px;
    margin-bottom: 24px;
    line-height: 28px;

    @media (--to-desktop) {
      width: 100%;
    }

    @media (--only-mobile) {
      line-height: 24px;
    }
  }
`;

export const lastProjectsGrid = css`
  display: grid;
  grid-auto-rows: 402px;
  grid-template-columns: repeat(3, 377px);
  padding: 0;
  margin: 0;
  column-gap: 24px;
  list-style: none;

  @media (--only-desktop) {
    grid-template-columns: repeat(2, 458px);
    row-gap: 24px;
  }

  @media (--only-tablet) {
    grid-auto-rows: 350px;
    grid-template-columns: repeat(2, 318px);
    row-gap: 24px;
  }

  @media (--only-mobile) {
    grid-template-columns: repeat(1, 100%);
    column-gap: 0;
    row-gap: 16px;
  }
`;

export const projectPrice = css`
  && {
    font-weight: 800;
    font-size: 18px;
    line-height: 22px;
  }
`;

export const projectButton = css`
  margin-top: auto;
`;
